<div class="date-control">
  <label>{{ !hideTitle ? filterBase.label : '&nbsp;' }}</label>
  <div class="date-input-wrap">
    <input type="date" [attr.aria-label]="filterBase.label" [(ngModel)]="selectedValue" (ngModelChange)="onDateChange($event)" class="date-field">
    <mat-icon aria-hidden="true">calendar_today</mat-icon>
  </div>
</div>
